import { GradientArea } from '../../Common/Charts/GradientArea';
import { useEpidemiologyChartsDataContext } from './hooks/useEpidemiologyChartsDataContext';

export const MortalityEvolution = () => {
    const { chartData } = useEpidemiologyChartsDataContext();

    const mortalityByYear = chartData?.epidemiologyMortalityEvolution || {};

    const subtitles = Object.keys(mortalityByYear);
    const values = Object.values(mortalityByYear);

    return (
        <GradientArea
            title="Taxa de Mortalidade por Ano"
            values={values}
            subtitles={subtitles}
            height={450}
        />
    );
};